(() => {
  if (customElements.get('hx-cellular-story')) return;
  customElements.define('hx-cellular-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('[data-chrono-index]')];
      this.cards = [...this.querySelectorAll('[data-chrono-card]')];
      this.rail = this.querySelector('.hx-chrono-cards');
      if (!this.buttons.length || !this.rail) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index), options));
      this.querySelectorAll('[data-chrono-step]').forEach(button => button.addEventListener('click', () => this.select(this.index + Number(button.dataset.chronoStep)), options));
      this.querySelector('.hx-chrono-nav').addEventListener('keydown', event => {
        const index = this.buttons.indexOf(event.target);
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : Math.max(0, Math.min(this.buttons.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
        this.buttons[next].focus({ preventScroll: true });
        this.select(next);
      }, options);
      const sync = () => {
        if (!this.mobile.matches) return;
        const left = this.rail.getBoundingClientRect().left;
        const distances = this.cards.map(card => Math.abs(card.getBoundingClientRect().left - left));
        this.select(distances.indexOf(Math.min(...distances)), false);
      };
      this.rail.addEventListener('scrollend', sync, options);
      this.rail.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(sync, 140);
      }, { ...options, passive: true });
      this.updateMotion = () => this.toggleAttribute('data-motion', Boolean(this.visible && !document.hidden && !this.motion.matches));
      document.addEventListener('visibilitychange', this.updateMotion, options);
      this.motion.addEventListener('change', this.updateMotion, options);
      this.mobile.addEventListener('change', () => this.select(this.index, true), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.updateMotion();
      }, { threshold: 0.08 });
      this.observer.observe(this);
      this.select(0, false);
    }
    select(index, scroll = true) {
      if (index < 0 || index >= this.buttons.length) return;
      this.index = index;
      this.buttons.forEach((button, i) => {
        button.classList.toggle('is-active', i === index);
        button.setAttribute('aria-pressed', String(i === index));
      });
      this.cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
      this.style.setProperty('--hx-chrono-progress', (index / (this.buttons.length - 1) * 100) + '%');
      this.querySelector('[data-chrono-current]').textContent = String(index + 1).padStart(2, '0');
      this.querySelector('[data-chrono-step="-1"]').disabled = index === 0;
      this.querySelector('[data-chrono-step="1"]').disabled = index === this.buttons.length - 1;
      if (scroll && this.mobile.matches) {
        clearTimeout(this.scrollTimer);
        const left = this.cards[index].getBoundingClientRect().left - this.rail.getBoundingClientRect().left + this.rail.scrollLeft;
        this.rail.scrollTo({ left, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      clearTimeout(this.scrollTimer);
    }
  });
})();
